import React from 'react';
import HeaderOne from '../common/header/HeaderOne';
import FooterOne from '../common/footer/FooterOne';
import Breadcrumb from '../common/breadcrumb/Breadcrumb';
import { SearchBar } from '@/components/search';
import { SearchResults } from '@/components/search';
import { SearchFilters } from '@/components/search';

const Search: React.FC = () => {
  return (
    <>
      <HeaderOne />
      <Breadcrumb
        title="Search"
        currentPage="Search"
        img="/assets/images/backgrounds/breadcrumb-bg.jpg"
      />

      <section className="py-12 bg-cream">
        <div className="container mx-auto px-4">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-bark mb-4">
              Search Our Directory
            </h1>
            <p className="text-muted-foreground">
              Find local farms, markets, and fresh produce in Southwest Florida
            </p>
          </div>

          <div className="mb-8">
            <SearchBar
              variant="large"
              autoFocus
              className="max-w-2xl"
            />
          </div>

          <div className="flex flex-col lg:flex-row gap-8">
            {/* Filters Sidebar */}
            <aside className="w-full lg:w-72 flex-shrink-0">
              <SearchFilters variant="sidebar" />
            </aside>

            {/* Results */}
            <main className="flex-1">
              <SearchResults />
            </main>
          </div>
        </div>
      </section>

      <FooterOne />
    </>
  );
};

export default Search;
